export default {
  photo () {
    const self = this
    if (self.photo instanceof File) {
      const reader = new FileReader()

      reader.readAsDataURL(self.photo)

      reader.onload = function () {
        self.testimonial.photo = reader.result
      }
    }
  },
}
